import React from "react"
import FormsLogo from "../images/efax.svg"

const Help = () => {
  return (
    <div className="container">
      <div className="header-container">
        <div className="logo-container">
          <img src={FormsLogo} height={36} width={200} alt="Consensus Logo" />
          <div className="logo-label" style={{ color: "#000" }}>
            |
          </div>
          <div className="logo-label">Bulk Faxing - Help & Instructions</div>
        </div>
      </div>
      <div className="white-bg">
        <div className="helpBody" style={{ padding: "0px 30px" }}>
          <div className="helpSection">
            <h2 className="helpMainTopics">Send Bulk Fax</h2>
            <div className="helpTopics">
              <ol style={{ paddingLeft: "20px" }}>
                <li>
                  Click <strong>Upload</strong> and select the files you want to
                  send.
                </li>
                <li>
                  Prepare your recipients list:
                  <ul>
                    <li>
                      - Use a <strong>plain text (.txt)</strong> or{" "}
                      <strong>CSV (.csv)</strong> file.
                    </li>
                    <li>
                      - Each line must contain <strong>one fax number.</strong>
                    </li>
                    <li>
                      - Name the file <strong>sendFaxNumbers.txt</strong> or{" "}
                      <strong>sendFaxNumbers.csv</strong>.
                    </li>
                  </ul>
                </li>
                <li>
                  Click <strong>Send Bulk Fax </strong> to submit and send the
                  fax to all recipients.
                </li>
              </ol>
            </div>

            <h2 className="helpMainTopics">Address Book</h2>
            <div className="helpTopics">
              <ol style={{ paddingLeft: "20px" }}>
                <li>
                  Click <strong>Create Folder</strong>, enter a folder name, and
                  create the folder.
                </li>
                <li>
                  Prepare your recipients list:
                  <ul>
                    <li>
                      - Use a <strong>plain text (.txt)</strong> or{" "}
                      <strong>CSV (.csv)</strong> file.
                    </li>
                    <li>
                      - Each line must contain <strong>one fax number.</strong>
                    </li>
                    <li>
                      - Name the file <strong>sendFaxNumbers.txt</strong> or{" "}
                      <strong>sendFaxNumbers.csv</strong>.
                    </li>
                  </ul>
                </li>
                <li>
                  Click the <strong>Add ➕</strong> action to add files to the
                  folder.
                </li>
                <li>
                  Click the <strong>Send Bulk Fax ➡️ </strong> action to send
                  the bulk fax.
                </li>
                <li>
                  Click the <strong> Delete 🗑️ </strong> action to delete the
                  folder.
                </li>
              </ol>
            </div>
          </div>

          <div className="helpSection">
            <h2 className="helpMainTopics">Using the Address Book</h2>
            <div className="helpTopics">
              The left-hand panel allows you to manage your Address Book
              efficiently:
              <ul>
                - You can create up to <strong>12 folders</strong> using the{" "}
                <strong>Create Folder</strong> button.
                <br />- Each folder can store{" "}
                <strong>uploaded documents</strong> and{" "}
                <strong>recipient files.</strong>
                <br />- Use the <strong>Add ➕ </strong> action to upload files
                to a folder.
                <br />- Use the <strong>Download ⬇️</strong> and{" "}
                <strong>Delete 🗑️</strong> actions to manage existing files.
              </ul>
            </div>
          </div>

          <div className="helpSection">
            <h2 className="helpMainTopics">Search & Filter Faxes</h2>
            <div className="helpTopics">
              <ul>
                <li>
                  - Use the <strong>Date range</strong> pickers to filter faxes
                  by sent <strong>From Date</strong> and{" "}
                  <strong>To Date</strong>.
                </li>
                <li>
                  - Use the <strong>Status </strong> dropdown to view faxes with
                  the following statuses: <strong>ALL</strong>,{" "}
                  <strong>ERROR</strong> and <strong>COMPLETE.</strong>
                </li>
                <li>
                  - Use the <strong>“Filter by Time”</strong> to narrow results
                  based on when faxes were sent, either from the{" "}
                  <strong>Address Book</strong> or the <strong>Root</strong>, as
                  applicable.
                </li>
                <li>
                  - Click the <strong>Reset ↺</strong> icon to clear all applied
                  filters.
                </li>
                <li>
                  - Click <strong>Export to CSV</strong> to download the
                  filtered results.
                </li>
                <li>
                  - Use the <strong>pagination controls</strong> at the bottom
                  of the fax log to navigate through multiple pages of results.
                </li>
              </ul>
            </div>
          </div>

          {/* <div className="helpSection">
            <h2 className="helpMainTopics">Managing Files</h2>
            <div className="helpTopics">
              - Click the <strong>down arrow</strong> beside a file to download
              it.
              <br />- Click the <strong>red "X"</strong> beside a file to delete
              it.
              <br />- Uploaded files are grouped by folder in the Address Book
              panel.
            </div>
          </div> */}

          {/* <div className="helpSection">
            <h2 className="helpMainTopics">Fax Status Messages</h2>
            <div className="helpTopics">
              - “<strong>Communication error</strong>” indicates a failed
              attempt to reach the recipient fax.
              <br />- You can retry failed faxes by{" "}
              <strong>Send bulk fax</strong> action
            </div>
          </div> */}
        </div>
      </div>
    </div>
  )
}

export default Help
